import { render } from "./defaultTouchspin.vue?vue&type=template&id=7b1d9416"
import script from "./defaultTouchspin.vue?vue&type=script&lang=js"
export * from "./defaultTouchspin.vue?vue&type=script&lang=js"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__